import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.navDropdowns();
        this.partnerSlider();
        this.cardsSlider();
        this.carouselSlider();
        this.imageCarouselSlider();
        this.videoCarouselSlider();
        this.videoCardsSlider();
        this.videoPlayButtons();
        this.honeyForms();
        this.videos();
        this.testimonials();
        this.headerTitleMask();
        this.photoUploadSlots();
    }

    navDropdowns() {
        document.querySelectorAll('.main-navbar__dropdown-toggle').forEach(button => {
            button.addEventListener('click', () => {
                const navItem  = button.closest('.main-navbar__nav-item');
                const dropdown = navItem.querySelector('.main-navbar__dropdown');

                if (!dropdown) return;

                const isOpen = dropdown.classList.contains('main-navbar__dropdown--open');

                // Close all other open dropdowns first
                document.querySelectorAll('.main-navbar__dropdown--open').forEach(openDropdown => {
                    openDropdown.classList.remove('main-navbar__dropdown--open');
                });

                document.querySelectorAll('.main-navbar__dropdown-toggle--open').forEach(openButton => {
                    openButton.classList.remove('main-navbar__dropdown-toggle--open');
                });

                if (!isOpen) {
                    dropdown.classList.add('main-navbar__dropdown--open');
                    button.classList.add('main-navbar__dropdown-toggle--open');
                }
            });
        });
    }

    partnerSlider() {
        document.querySelectorAll('.partners__list').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('.partners').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                // pagination: paginationOptions,
                autoplay: true,
                loop: true,
                breakpoints: {
                    0: {
                        spaceBetween: 60,
                        slidesPerView: 2,
                    },
                    500: {
                        spaceBetween: 60,
                        slidesPerView: 3,
                    },
                    576: {
                        spaceBetween: 60,
                        slidesPerView: 4,
                    },
                    768: {
                        spaceBetween: 60,
                        slidesPerView: 5,
                    },
                    992: {
                        spaceBetween: 60,
                        slidesPerView: 6,
                    },
                    1200: {
                        spaceBetween: 60,
                        slidesPerView: 6,
                    },
                    1400: {
                        spaceBetween: 90,
                        slidesPerView: 6
                    }
                },
                slidesPerGroup: 1
            });
        });
    }

    cardsSlider() {
        document.querySelectorAll('.cards__list').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('.cards').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                // pagination: paginationOptions,
                spaceBetween: 15,
                autoplay: true,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 3
                    },
                    1400: {
                        slidesPerView: 'auto'
                    }
                },
                slidesPerGroup: 1
            });
        });
    }

    carouselSlider() {
        document.querySelectorAll('.carousel__slider').forEach(element => {
            const id = element.getAttribute('id');
            const sectionId = id.replace('carousel-main-', '');

            const thumbsSwiper = new Swiper(`#carousel-thumbs-${sectionId}`, {
                spaceBetween: 10,
                slidesPerView: 5,
                watchSlidesProgress: true,
                breakpoints: {
                    0: {
                        slidesPerView: 3,
                        spaceBetween: 8,
                    },
                    576: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    }
                }
            });

            new Swiper(`#carousel-swiper-${sectionId}`, {
                spaceBetween: 10,
                thumbs: {
                    swiper: thumbsSwiper,
                },
                navigation: {
                    prevEl: `#carousel-prev-${sectionId}`,
                    nextEl: `#carousel-next-${sectionId}`,
                },
            });
        });
    }

    imageCarouselSlider() {
        document.querySelectorAll('.image-carousel__slider').forEach(element => {
            const id = element.getAttribute('id');
            const sectionId = id.replace('image-carousel-main-', '');

            new Swiper(`#image-carousel-swiper-${sectionId}`, {
                spaceBetween: 20,
                loop: true,
                navigation: {
                    prevEl: `#image-carousel-prev-${sectionId}`,
                    nextEl: `#image-carousel-next-${sectionId}`,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.5
                    },
                    576: {
                        slidesPerView: 2.5
                    },
                    768: {
                        slidesPerView: 3.5
                    },
                    992: {
                        slidesPerView: 4.5
                    },
                    1200: {
                        slidesPerView: 5.5
                    },
                    1400: {
                        slidesPerView: 6
                    }
                }
            });
        });
    }

    videoCarouselSlider() {
        document.querySelectorAll('.video-carousel__slider').forEach(element => {
            const id = element.getAttribute('id');
            const sectionId = id.replace('video-carousel-main-', '');

            const swiper = new Swiper(`#video-carousel-swiper-${sectionId}`, {
                spaceBetween: 20,
                loop: true,
                centeredSlides: true,
                navigation: {
                    prevEl: `#video-carousel-prev-${sectionId}`,
                    nextEl: `#video-carousel-next-${sectionId}`,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.4
                    },
                    576: {
                        slidesPerView: 2.2
                    },
                    768: {
                        slidesPerView: 3
                    },
                    992: {
                        slidesPerView: 3.5
                    },
                    1200: {
                        slidesPerView: 4.5
                    },
                    1400: {
                        slidesPerView: 5
                    }
                }
            });

            // Pause video when slide changes
            swiper.on('slideChange', () => {
                element.querySelectorAll('video').forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                });
                element.querySelectorAll('.video-play-button').forEach(button => {
                    button.classList.remove('video-play-button--hidden');
                });
            });
        });
    }

    videoCardsSlider() {
        document.querySelectorAll('.video-cards__slider').forEach(element => {
            const id = element.getAttribute('id');
            const sectionId = id.replace('video-cards-main-', '');
            const section = element.closest('.video-cards');

            const swiper = new Swiper(`#video-cards-swiper-${sectionId}`, {
                spaceBetween: 20,
                loop: true,
                navigation: {
                    prevEl: `#video-cards-prev-${sectionId}`,
                    nextEl: `#video-cards-next-${sectionId}`,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    992: {
                        slidesPerView: 2
                    }
                }
            });

            // Pause video when slide changes
            swiper.on('slideChange', () => {
                section.querySelectorAll('video').forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                });
                section.querySelectorAll('.video-play-button').forEach(button => {
                    button.classList.remove('video-play-button--hidden');
                });
            });
        });
    }

    videoPlayButtons() {
        document.querySelectorAll('[data-video-play]').forEach(button => {
            const screen = button.parentElement;
            const video = screen.querySelector('video');

            if (!video) return;

            button.addEventListener('click', () => {
                if (video.paused) {
                    video.muted = false;
                    video.play();
                    button.classList.add('video-play-button--hidden');
                } else {
                    video.pause();
                    button.classList.remove('video-play-button--hidden');
                }
            });
        });
    }


    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    videos() {
        const playVideo = async (video, { muted = false } = {}) => {
            video.muted = muted;

            try {
                await video.play();
            }
            catch (err) {
                if (err.name === 'NotAllowedError') {
                    video.classList.add('blocked');
                }
            }
        };

        document.querySelectorAll('[data-hover-play]').forEach(async element => {
            const video = element.querySelector('video');

            if (!video) {
                return;
            }

            element.addEventListener('pointerenter', async () => {
                await playVideo(video, { muted: false });
            });

            element.addEventListener('pointerleave', () => video.pause());

            // Autoplay for mobile (muted only)
            if (window.innerWidth <= 992) {
                await playVideo(video, { muted: true });
            }
        });

        // Detect first user interaction (unblocks sound)
        const handleFirstInteraction = () => {
            // Remove all "blocked" classes from videos
            document.querySelectorAll('[data-hover-play] video.blocked').forEach(video => {
                video.classList.remove('blocked');
            });

            // Prevent this from running more than once
            window.removeEventListener('click', handleFirstInteraction)
        };

        // Listen for first real user click to unlock
        window.addEventListener('click', handleFirstInteraction);
    }

    testimonials() {
        const testimonials = document.getElementById('testimonials');

        if (testimonials === null) {
            return;
        }

        const cols = Array.from(testimonials.querySelectorAll('.testimonials__item'));

        const state = cols.map(col => ({
            col,
            track: col.querySelector('.testimonials__track'),
            dir: col.dataset.dir, // "up" | "down"
            y: 0,
            max: 0,
            v: 100, // px/sec tweak
        }));

        // --- responsive "merge tracks" setup ---
        const col1 = document.getElementById('column-1');
        const col2 = document.getElementById('column-2');
        const col3 = document.getElementById('column-3');

        const track1 = col1.querySelector('.testimonials__track');
        const track2 = col2.querySelector('.testimonials__track');
        const track3 = col3.querySelector('.testimonials__track');

        // Store original cards (so we can restore perfectly)
        const original = {
            t1: Array.from(track1.children),
            t2: Array.from(track2.children),
            t3: Array.from(track3.children),
        };

        function restoreOriginal() {
            // Put everything back exactly as it was
            track1.replaceChildren(...original.t1);
            track2.replaceChildren(...original.t2);
            track3.replaceChildren(...original.t3);

            col2.classList.remove('testimonials__item--hidden');
            col3.classList.remove('testimonials__item--hidden');
        }

        function applyResponsiveTracks() {
            const w = window.innerWidth;

            // Always start from a clean known state
            restoreOriginal();

            if (w <= 992) {
                // Smallest: only col-1 visible, move col-2 + col-3 cards into track1
                col2.classList.add('testimonials__item--hidden');
                col3.classList.add('testimonials__item--hidden');

                const merged = [
                    ...original.t1,
                    ...original.t2,
                    ...original.t3,
                ];
                track1.replaceChildren(...merged);
            } else if (w <= 1200) {
                // Small: col-1 + col-2 visible, move col-3 cards into track2
                col3.classList.add('testimonials__item--hidden');

                const merged2 = [
                    ...original.t2,
                    ...original.t3,
                ];
                track2.replaceChildren(...merged2);
            }

            // IMPORTANT: your existing state objects reference .track nodes.
            // After moving cards, the track elements are the same, only children changed.
            // So just re-measure to update max/positions.
            measure();

            updateAutoScrollMode();
        }

        let raf = null;
        let last = 0;
        let hovering = false;

        function setTransform(s) {
            s.track.style.transform = `translate3d(0, ${-s.y}px, 0)`;
        }

        function isVisible(el) {
            return !!el.offsetParent;
        }

        function isMobile() {
            return window.innerWidth <= 992;
        }

        function measure() {
            state.forEach(s => {
                if (!isVisible(s.col)) return;

                const overflow = s.track.scrollHeight - s.col.clientHeight;
                s.max = Math.max(0, overflow);

                s.y = (s.dir === "down") ? s.max : 0;
                setTransform(s);
            });
        }

        function tick(ts) {
            if (!hovering) return;

            const dt = Math.min(0.05, (ts - last) / 1000 || 0);
            last = ts;

            state.forEach(s => {
                if (!isVisible(s.col)) return;
                if (s.max <= 0) return;

                const dir = (s.dir === "up") ? +1 : -1;
                s.y = Math.min(s.max, Math.max(0, s.y + dir * s.v * dt));
                setTransform(s);
            });

            raf = requestAnimationFrame(tick);
        }

        function start() {
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                return;
            }

            if (hovering) {
                return;
            }

            hovering = true;

            state.forEach(s => {
                if (!isVisible(s.col)) {
                    return;
                }

                s.track.style.transition = "none";
            });

            cancelAnimationFrame(raf);
            last = performance.now();
            raf = requestAnimationFrame(tick);
        }

        function stopAndReturn() {
            hovering = false;
            cancelAnimationFrame(raf);

            state.forEach(s => {
                if (!isVisible(s.col)) return;
                s.track.style.transition = "transform 700ms cubic-bezier(.2,.8,.2,1)";
                s.y = (s.dir === "down") ? s.max : 0;
                setTransform(s);
            });
        }

        let mobileAutoScrollActive = false;

        function updateAutoScrollMode() {
            if (isMobile()) {
                // Start auto-scroll on mobile
                if (!mobileAutoScrollActive) {
                    start();
                    mobileAutoScrollActive = true;
                }

                // Disable hover listeners (mobile safety)
                testimonials.removeEventListener('mouseenter', start);
                testimonials.removeEventListener('mouseleave', stopAndReturn);
            }
            else {
                // Desktop behavior
                if (mobileAutoScrollActive) {
                    stopAndReturn();
                    mobileAutoScrollActive = false;
                }

                testimonials.addEventListener('mouseenter', start);
                testimonials.addEventListener('mouseleave', stopAndReturn);
            }
        }

        /*let touchTimeout;

        testimonials.addEventListener('touchstart', () => {
            if (!isMobile()) {
                return;
            }

            stopAndReturn();

            clearTimeout(touchTimeout);
        });

        testimonials.addEventListener('touchend', () => {
            if (!isMobile()) {
                return;
            }

            touchTimeout = setTimeout(start, 1500);
        });*/

        testimonials.addEventListener('mouseenter', start);
        testimonials.addEventListener('mouseleave', stopAndReturn);

        window.addEventListener('resize', applyResponsiveTracks);

        applyResponsiveTracks();

        setTimeout(applyResponsiveTracks, 100);
    }

    headerTitleMask() {
        function enableTitleCutoutOnVideoHover() {
            const media = document.querySelector('.header__media[data-hover-play]');
            const title = document.querySelector('.header__title');
            if (!media || !title) return;

            let svgMask; // the inline SVG element
            const MASK_ID = 'title-video-cutout-mask';
            const CUTOUT_OPACITY = 0.45; // 0 = no cutout (title fully visible), 1 = full cutout (fully transparent)

            function createSvgMask(titleRect) {
                if (svgMask) svgMask.remove();

                svgMask = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svgMask.setAttribute('width', Math.max(1, Math.round(titleRect.width)));
                svgMask.setAttribute('height', Math.max(1, Math.round(titleRect.height)));
                svgMask.setAttribute('viewBox', `0 0 ${titleRect.width} ${titleRect.height}`);
                svgMask.setAttribute('aria-hidden', 'true');
                svgMask.style.position = 'absolute';
                svgMask.style.left = `${titleRect.left + window.scrollX}px`;
                svgMask.style.top = `${titleRect.top + window.scrollY}px`;
                svgMask.style.pointerEvents = 'none';

                svgMask.innerHTML = `
                  <defs>
                    <mask id="${MASK_ID}" maskUnits="userSpaceOnUse">
                      <rect x="0" y="0" width="${titleRect.width}" height="${titleRect.height}" fill="white"/>
                      <rect id="cutout" x="0" y="0" width="0" height="0" fill="black" fill-opacity="${CUTOUT_OPACITY}"/>
                    </mask>
                  </defs>
                `;
                document.body.appendChild(svgMask);
            }

            function updateMask() {
                if (!svgMask) return;
                const titleRect = title.getBoundingClientRect();
                const videoRect = media.getBoundingClientRect();

                const ix = Math.max(titleRect.left, videoRect.left);
                const iy = Math.max(titleRect.top, videoRect.top);
                const iw = Math.max(0, Math.min(titleRect.right, videoRect.right) - ix);
                const ih = Math.max(0, Math.min(titleRect.bottom, videoRect.bottom) - iy);

                svgMask.style.left = `${titleRect.left + window.scrollX}px`;
                svgMask.style.top = `${titleRect.top + window.scrollY}px`;
                svgMask.setAttribute('width', Math.max(1, Math.round(titleRect.width)));
                svgMask.setAttribute('height', Math.max(1, Math.round(titleRect.height)));
                svgMask.setAttribute('viewBox', `0 0 ${titleRect.width} ${titleRect.height}`);

                const cutout = svgMask.querySelector('#cutout');
                cutout.setAttribute('x', Math.round(ix - titleRect.left));
                cutout.setAttribute('y', Math.round(iy - titleRect.top));
                cutout.setAttribute('width', Math.round(iw));
                cutout.setAttribute('height', Math.round(ih));
                cutout.setAttribute('fill-opacity', String(CUTOUT_OPACITY));

                title.style.mask = `url(#${MASK_ID})`;
                title.style.webkitMask = `url(#${MASK_ID})`;
                title.style.maskRepeat = 'no-repeat';
                title.style.webkitMaskRepeat = 'no-repeat';
            }

            function onEnter() {
                const titleRect = title.getBoundingClientRect();
                createSvgMask(titleRect);
                updateMask();
                window.addEventListener('resize', updateMask);
                window.addEventListener('scroll', updateMask, { passive: true });
            }

            function onLeave() {
                title.style.mask = '';
                title.style.webkitMask = '';
                if (svgMask) svgMask.remove();
                svgMask = null;
                window.removeEventListener('resize', updateMask);
                window.removeEventListener('scroll', updateMask);
            }

            media.addEventListener('mouseenter', onEnter);
            media.addEventListener('mouseleave', onLeave);
        }

        // Initialize title cutout effect
        enableTitleCutoutOnVideoHover();
    }

    photoUploadSlots() {
        document.querySelectorAll('[data-photo-slot]').forEach(slot => {
            const input   = slot.querySelector('[data-photo-input]');
            const preview = slot.querySelector('[data-photo-preview]');
            const add     = slot.querySelector('[data-photo-add]');
            const remove  = slot.querySelector('[data-photo-remove]');

            if (!input || !preview || !add) return;

            input.addEventListener('change', () => {
                const file = input.files[0];

                if (!file) return;

                const reader = new FileReader();

                reader.onload = (e) => {
                    preview.style.backgroundImage = `url('${e.target.result}')`;
                    preview.classList.add('form-photos__preview--visible');
                    add.classList.add('form-photos__add--hidden');

                    if (remove) {
                        remove.classList.add('form-photos__remove--visible');
                    }
                };

                reader.readAsDataURL(file);
            });

            if (remove) {
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    input.value                    = '';
                    preview.style.backgroundImage  = '';
                    preview.classList.remove('form-photos__preview--visible');
                    add.classList.remove('form-photos__add--hidden');
                    remove.classList.remove('form-photos__remove--visible');
                });
            }
        });
    }
}

window.addEventListener('load', () => new App());
